import { render } from "./privacyAgreement.vue?vue&type=template&id=0de9b7ba"
const script = {}

import "./privacyAgreement.vue?vue&type=style&index=0&id=0de9b7ba&lang=css"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__